import { apiService as api } from './api'; // Adapte selon ton export

const proposalService = {
  // Récupérer les propositions du partenaire
  getPartnerProposals: async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      
      if (filters.status) {
        params.append('status', filters.status);
      }

      const response = await api.get(`/proposals/supadmin/partner?${params}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erreur lors de la récupération des propositions');
    }
  },

  // Soumettre une nouvelle proposition
  submitProposal: async (proposalData) => {
    try {

      const response = await api.post('/proposals/supadmin', proposalData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erreur lors de la soumission de la proposition');
    }
  },

  // Modifier une proposition
  updateProposal: async (proposalId, updates) => {
    try {
      const response = await api.put(`/proposals/supadmin/${proposalId}`, updates);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erreur lors de la modification de la proposition');
    }
  },

  // Supprimer une proposition
  deleteProposal: async (proposalId) => {
    try {
      const response = await api.delete(`/proposals/supadmin/${proposalId}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Erreur lors de la suppression de la proposition');
    }
  }
};

export default proposalService;